import { setRemoteDefinitions } from '@nx/angular/mf';
import { BrowserWindowAdapter } from './services/browser-window';
import { ExternalConfigService } from './services/external-config.service';

BrowserWindowAdapter.propagateCspNonceToWebpack();

ExternalConfigService.loadAppConfig();

setRemoteDefinitions(ExternalConfigService.Config.remotes);

import('./bootstrap').catch((err) => console.error(err));
